import Marionette from 'backbone.marionette';

import ContactView from '../../base/views/contacts';
import MealPickerView from '../views/mealpicker';

const MealLayoutView = Marionette.LayoutView.extend({
  template: require('../templates/layout.html'),

  regions: {
    contacts: '#contacts-hook',
    mealpicker: '#mealpicker-hook'
  },

  ui: {
    save: '.button.save',
    load: '.loadingBox'
  },

  triggers: {
    'click @ui.save': 'save'
  },

  modelEvents: {
    'saved': 'onModelSaved',
    'save:fail': 'onModelSaved'
  },

  onModelSaved() {
    this.ui.save.removeAttr('disabled').removeClass('disabled');
    this.ui.load.addClass('hidden');
  },

  onSave() {
    this.ui.save.prop('disabled', 'disabled').addClass('disabled');
    this.ui.load.removeClass('hidden');
    this.model.sync();
  },

  onShow() {
    var contactView = new ContactView({
      filter: this.model.get('contacts')
    });
    this.showChildView('contacts', contactView);

    var mealpicker = new MealPickerView({
      model: this.model
    });
    this.showChildView('mealpicker', mealpicker);
  }
});

module.exports = MealLayoutView;



// WEBPACK FOOTER //
// ./menupicker/views/layout.js